import React, { useEffect, useState } from 'react';
import { Search, Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

// Step 1 — find the job by A-number, client name/phone/email or street.
export const JobFinder = ({ onPick, clientId, propertyId }) => {
  const { api } = useAuth();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  const run = async (params) => {
    setBusy(true);
    try { setRows((await api.get(`/update-resend/find?${new URLSearchParams(params)}`)).data.rows || []); }
    finally { setBusy(false); }
  };
  useEffect(() => {
    if (clientId) run({ client_id: clientId });
    else if (propertyId) run({ property_id: propertyId });
  }, [clientId, propertyId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="bg-white border border-[#E2E2DF] rounded-md p-4 space-y-3" data-testid="ur-finder">
      <div className="flex gap-2">
        <input data-testid="ur-search-input" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && run({ q })}
          placeholder="A-number, client name, phone, email or street…" className="flex-1 px-3 py-2 text-sm border border-[#E2E2DF] rounded focus:outline-none focus:ring-2 focus:ring-[#0F4F1B]/30" />
        <button data-testid="ur-search-btn" onClick={() => run({ q })} className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-semibold rounded-md bg-[#0F4F1B] text-white hover:bg-[#0a3c14]">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <Search size={13} />} Find job
        </button>
      </div>
      <div className="divide-y divide-[#F1EFEC]">
        {rows.map((r) => (
          <button key={r.id} data-testid={`ur-job-${r.appraisal_no}`} onClick={() => onPick(r.id)}
            className="w-full text-left grid grid-cols-[80px_1fr_1fr_120px_70px] gap-2 py-2 px-1 text-xs hover:bg-slate-50 transition-colors">
            <span className="font-mono font-semibold">A{r.appraisal_no}</span><span>{r.client_name}</span>
            <span className="text-slate-500 truncate">{r.address}</span><span className="text-slate-500">{r.status}</span>
            <span className="text-slate-400">{r.quotes ? `${r.quotes} quotes` : 'single'}</span>
          </button>
        ))}
        {!busy && rows.length === 0 && <div className="text-xs text-slate-400 py-2">Search to find the job you want to update.</div>}
      </div>
    </div>
  );
};
